import { combineReducers } from "redux";
import authReducer from "src/reducers/authReducer";
import userReducer from "src/reducers/userReducer";
import pageReducer from "src/reducers/pageReducer";
import siteSettingsReducer from "src/reducers/siteReducer";
import operatorReducer from "src/reducers/operatorReducer";
import userDetailsReducer from "src/reducers/userDetailsReducer";
import workspaceDetailsReducer from "src/reducers/workspaceDetailsReducer";
import collapseReducer from "src/reducers/collapseReducer";
import menuReducer from "src/reducers/menuReducer";
import groupReducer from "src/reducers/groupReducer";
import workspaceReducer from "src/reducers/workspaceReducer";
import emailerReducer from "src/reducers/emailerReducer";
import ssoReducer from "src/reducers/ssoReducer";
import activityReducer from "src/reducers/activityReducer";
import siteCredentialReducer from "src/reducers/siteCredentialReducer";

export default combineReducers({
  auth: authReducer,
  users: userReducer,
  pages: pageReducer,
  site: siteSettingsReducer,
  operators: operatorReducer,
  userDetails: userDetailsReducer,
  workspaceDetails: workspaceDetailsReducer,
  collapse: collapseReducer,
  menus: menuReducer,
  sso: ssoReducer,
  activity: activityReducer,
  creds: () => {
    return {
      clientId: "ac807a50-a522-4dd4-8cac-2ff0a3544e2d",
      clientSecret: "b1ffda60aa2fb8478ae61a90380caf45cf953041e4198505e283ee4484b912e7",
      datasetId: "a0f1e7d0-ea47-4287-8fc3-d2aafd53bd24",
      portalDatasetId: "8eec335b-67f0-4098-a405-31e49bf5a0e8",
    };
  },
  groups: groupReducer,
  workspaces: workspaceReducer,
  emailers: emailerReducer,
  pageCredentialOptions: siteCredentialReducer,
});
